export const SUCCESS_COLOR = "#00E676"
export const INFO_COLOR = "#1976D2"
export const ERROR_COLOR = "#62D4D2"